var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4995_34406)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "#0061FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.729 70.8625L67.9322 19.0645L52.3942 37.9484L39.1674 24.7216L24.727 39.162L36.2704 50.7059L19.0596 67.9169L70.9567 119.813L119.729 70.8625Z",
    fill: "#004FCF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4995_34406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9002 18.6426H55.1514C49.5303 18.6426 44.9561 23.2168 44.9561 28.8379V40.5868C44.9561 41.3918 45.6075 42.0432 46.4125 42.0432H58.0643C63.6854 42.0432 68.3567 37.3719 68.3567 31.7508V20.0991C68.3567 19.294 67.7053 18.6426 66.9002 18.6426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0643 44.957H46.4125C45.6075 44.957 44.9561 45.6085 44.9561 46.4135V58.1624C44.9561 62.1777 48.2231 65.4448 52.2384 65.4448H63.9873C64.7923 65.4448 65.4438 64.7933 65.4438 63.9883V52.2394C65.4438 48.2241 62.0796 44.957 58.0643 44.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5868 44.957H28.8379C23.2168 44.957 18.6426 49.5312 18.6426 55.1523V66.9012C18.6426 67.7063 19.294 68.3577 20.0991 68.3577H31.7508C37.3719 68.3577 42.0432 63.7835 42.0432 58.1624V46.4135C42.0432 45.6085 41.3918 44.957 40.5868 44.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.751 21.5547H23.0121C22.2071 21.5547 21.5557 22.2061 21.5557 23.0112V31.75C21.5557 37.3711 26.1299 42.0424 31.751 42.0424H40.5869C41.392 42.0424 42.0434 41.391 42.0434 40.5859V31.75C42.0434 26.1289 37.3721 21.5547 31.751 21.5547Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4995_34406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4995_34406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.7143,
    height: 49.7143,
    fill: "white",
    transform: "translate(18.6426 18.6426)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.6794b44f2872ce14996810f2a2e58b67.svg";
export { ForwardRef as ReactComponent };